import { FileText } from 'lucide-react';
import { Helmet } from 'react-helmet-async';

export function Terms() {
  return (
    <>
      <Helmet>
        <title>Vilkår og Betingelser | Aker Stadion Fanside</title>
        <meta 
          name="description" 
          content="Les våre vilkår og betingelser for bruk av Aker Stadion fansiden. Informasjon om bruksrettigheter, ansvarsfraskrivelser og personvern."
        />
      </Helmet>
      <div className="min-h-screen bg-gray-100">
        <div className="bg-[#2173B9] text-white py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center gap-3 mb-4">
              <FileText className="w-8 h-8" />
              <h1 className="text-3xl font-bold">Vilkår og betingelser</h1>
            </div>
            <p className="text-lg opacity-90">
              Betingelser for bruk av nettsiden
            </p>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="bg-white rounded-lg shadow-lg p-6">
            <div className="prose max-w-none">
              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
                <p className="text-sm text-yellow-700">
                  Denne nettsiden er en uoffisiell fanside og er ikke tilknyttet de offisielle 
                  representantene for Aker Stadion eller Molde FK.
                </p>
              </div>

              <h2 className="text-2xl font-bold mb-4">Introduksjon</h2>
              <p className="text-gray-600 mb-6">
                Disse vilkårene og betingelsene gjelder for bruk av nettsiden for Aker Stadion, 
                en uoffisiell informasjonsportal om stadionet og Molde FK. Ved å bruke denne 
                nettsiden, godtar du å overholde og være bundet av de følgende vilkårene og 
                betingelsene. Hvis du ikke aksepterer disse vilkårene, vennligst ikke bruk nettsiden.
              </p>

              <h3 className="text-xl font-bold mb-3">Bruk av nettsiden</h3>
              <p className="text-gray-600 mb-6">
                Nettsiden og innholdet er kun for informasjonsformål. Vi forsøker å gi nøyaktig 
                og oppdatert informasjon, men vi kan ikke garantere at alt innhold til enhver tid 
                er korrekt eller fullstendig. Bruk av informasjon fra denne nettsiden skjer på egen 
                risiko, og vi fraskriver oss ethvert ansvar for eventuelle feil eller utelatelser.
              </p>

              <h3 className="text-xl font-bold mb-3">Immaterielle rettigheter</h3>
              <p className="text-gray-600 mb-6">
                Alt innhold på denne nettsiden, inkludert tekst, bilder, grafikk og logoer, er 
                beskyttet av opphavsrett og andre immaterielle rettigheter. Du har ikke tillatelse 
                til å kopiere, distribuere, endre eller bruke noe av innholdet uten skriftlig 
                tillatelse fra rettighetshaverne.
              </p>

              <h3 className="text-xl font-bold mb-3">Lenker til tredjeparts nettsider</h3>
              <p className="text-gray-600 mb-6">
                Denne nettsiden kan inneholde lenker til eksterne nettsider som driftes av 
                tredjeparter. Vi har ingen kontroll over innholdet på disse sidene og kan derfor 
                ikke holdes ansvarlige for informasjonen eller tjenestene som tilbys der. Bruk av 
                tredjeparts nettsider skjer på egen risiko.
              </p>

              <h3 className="text-xl font-bold mb-3">Endringer i vilkår og betingelser</h3>
              <p className="text-gray-600">
                Vi forbeholder oss retten til å endre disse vilkårene og betingelsene når som helst. 
                Eventuelle endringer vil bli publisert på denne siden, og vi oppfordrer deg til å 
                sjekke denne siden regelmessig for oppdateringer.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
